<template>
  <el-dialog
    :title="$tt('工程交接')"
    :visible.sync="visible"
    @close="switchDialogVisible(false)"
    width="48%"
  >
    <div class="bindUser">
      <span class="label">{{ $tt("名称：") }}</span>
      <el-input
        :placeholder="$tt('请输入名称')"
        v-model="searchCnName"
        clearable
        width="400"
      >
      </el-input>
      <span class="label">{{ $tt("昵称：") }}</span>
      <el-input
        :placeholder="$tt('请输入昵称')"
        v-model="searchName"
        clearable
        width="400"
      >
      </el-input>
      <span class="label">{{ $tt("手机号：") }}</span>
      <el-input
        :placeholder="$tt('请输入手机号')"
        v-model="searchPhoneNumber"
        clearable
        width="400"
      >
      </el-input>
      <span class="label">{{ $tt("邮箱：") }}</span>
      <el-input
        :placeholder="$tt('请输入邮箱')"
        v-model="searchEmail"
        clearable
        width="400"
      >
      </el-input>
      <el-button
        type="primary"
        @click="
          getAllUsers({
            cn_name: searchCnName,
            nick_name: searchName,
            phone: searchPhoneNumber,
            email: searchEmail,
          })
        "
        >{{ $tt("搜索") }}</el-button
      >

      <div class="" v-if="visibleUsers.length > 0">
        <el-radio-group v-model="checkedUser">
          <el-radio :label="u.id" v-for="(u, i) in visibleUsers" :key="u.id">
            <span class="nickName">{{ u.cn_name || u.nick_name || `无名称${i}` }}</span>
            <span class="phone">{{ u.phone }}</span>
            <span class="phone" v-if="u.email">{{ u.email }}</span>
          </el-radio>
        </el-radio-group>
      </div>
      <el-empty :description="searched ? $tt('未找到匹配用户') : $tt('请先搜索接收人')" v-else></el-empty>
    </div>
    <span slot="footer">
      <el-button @click="switchDialogVisible(false)">{{ $tt("取 消") }}</el-button>
      <el-button type="primary" @click="onConfirm">{{ $tt("确 定") }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { loginUserId, parseUserPickerList } from "@/utils/account.js";

export default {
  props: {
    visible: Boolean,
    switchDialogVisible: Function,
    refresh: Function,
    projectIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      allUsersData: [],
      checkedUser: "",
      searchPhoneNumber: "",
      searchName: "",
      searchCnName: "",
      searchEmail: "",
      searched: false,
    };
  },
  computed: {
    visibleUsers() {
      const selfId = loginUserId(this.$store.state.loginAccountInfo);
      return (this.allUsersData || []).filter((u) => u && u.id !== selfId);
    },
  },
  methods: {
    hasSearch() {
      return !!(
        (this.searchCnName && this.searchCnName.trim()) ||
        (this.searchName && this.searchName.trim()) ||
        (this.searchPhoneNumber && this.searchPhoneNumber.trim()) ||
        (this.searchEmail && this.searchEmail.trim())
      );
    },
    getAllUsers(params) {
      if (!this.hasSearch()) {
        this.$message.warning("请至少填写一项再搜索");
        this.allUsersData = [];
        this.searched = false;
        this.checkedUser = "";
        return;
      }
      this.$request.queryAllUsers({ select_param: params }).then((res) => {
        if (res.status != "success") {
          this.$message.error(res.msg);
          return;
        }
        this.searched = true;
        const list = parseUserPickerList(res);
        const selfId = loginUserId(this.$store.state.loginAccountInfo);
        const others = list.filter((u) => u && u.id !== selfId);
        if (list.length > 0 && others.length === 0) {
          this.allUsersData = [];
          this.checkedUser = "";
          this.$message.warning("不能将工程交接给自己，请搜索其他接收人");
          return;
        }
        this.allUsersData = others.slice(0, 1);
        this.checkedUser = "";
        if (list.length > 1) {
          this.$message.info("匹配到多人，请用手机号精确搜索");
        }
      });
    },
    onConfirm() {
      if (!this.checkedUser) {
        this.$message.warning("请先搜索并选择接收人");
        return;
      }
      this.moveProject();
    },

    moveProject() {
      this.$request
        .moveProject({
          ids: this.projectIds,
          bind_user_id: this.checkedUser,
        })
        .then((res) => {
          if (res.status != "success") {
            this.$message.error(res.msg);
            return;
          }
          this.$message({
            showClose: true,
            message: "绑定成功",
            type: "success",
          });
          this.refresh(true);
        });
    },
    generateKey() {
      this.$refs.generateKeyForm.validate((valid) => {
        if (!valid) {
          return false;
        }
        const { use_scenes, timeRange, level, times } = this.generateKeyForm;
        this.$request
          .createSecretKey({
            start_time: timeRange[0].valueOf(),
            end_time: timeRange[1].valueOf(),
            use_scenes,
            level,
            num: times,
          })
          .then((res) => {
            if (res.status != "success") {
              this.$message.error(res.msg);
              return;
            }
            this.$message({
              showClose: true,
              message: "生成成功",
              type: "success",
            });
            this.refresh();
          });
      });
    },
  },
};
</script>

<style lang='scss'>
.generateKeyForm {
  .el-input--small,
  .el-input-number--small {
    width: 400px !important;
  }
}
.bindUser {
  max-height: 400px;
  overflow: auto;
  padding: 0 24px;
  .label {
    margin-right: 6px;
  }
  .el-input--small {
    width: 300px;
    margin: 0 12px 22px 0;
  }
  .nickName {
    width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    vertical-align: middle;
  }
  .phone {
    margin-left: 38px;
  }
  .el-radio {
    display: block;
    line-height: 34px;
  }
  .el-empty__image {
    width: 80px !important;
  }
  .el-empty {
    padding: 12px 0 !important;
  }
}
</style>